import { render, staticRenderFns } from "./HeroBanner.vue?vue&type=template&id=4931006e&scoped=true"
import script from "./HeroBanner.vue?vue&type=script&lang=ts"
export * from "./HeroBanner.vue?vue&type=script&lang=ts"
import style0 from "./HeroBanner.vue?vue&type=style&index=0&id=4931006e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4931006e",
  null
  
)

export default component.exports